import { AdTag } from '@carnica/ui-kit';
import { compose } from '@beef/redux';
import { withDataConverter, withRenderFlag } from '@beef/react';
import { dataConverter } from "./utils";
/**
 * Компонент LegalBadge отображает рекламный бейдж.
 *
 * @param {ILegalBadgeProps} props - Свойства компонента.
 * @param {string} [props.direction='upLeft'] - Направление отображения бейджа.
 * @param {string} [props.text='реклама'] - Текст для бэйджа.
 * @param {string} [props.textBadge='рекламодатель — ПАО «ВымпелКом»'] - Текст для тултипа бэйджа.
 * @param {string} [props.color='tertiary-invert'] - Цвет текста.
 * @param {string} [props.theme='light'] - Тема оформления.
 * @param {string} [props.className=''] - Дополнительные CSS классы.
 * @param {string} [props.portalClassName=''] - CSS класс для портала шторки в моб версии.
 * @param {string} [props.tooltipClassName=''] - CSS класс для тултипа.
 * @param {HTMLElement} [props.containerRef] - реф контейнера для корректировки поведения
 * @returns {JSX.Element} - Возвращает JSX элемент.
 */

export var LegalBadge = compose(withRenderFlag({
  shouldRenderFn: function shouldRenderFn(props) {
    return Boolean(props.text);
  }
}), withDataConverter(dataConverter))(AdTag);